import { Routes } from '@angular/router';
import { authGuard } from './features/auth/auth.guard';
import { StoryPage } from './pages/stories/pages/story/story.page';
import { StoriesPage } from './pages/stories/stories.page';
import { CommunityPage } from './pages/community/community.page';
import { CharactersPage } from './pages/characters/characters.page';
import { HomePage } from './pages/home/home.page';
import { MainTabsComponent } from './features/common/components/main-tabs/main-tabs.component';

export const routes: Routes = [
  {
    path: '',
    component: MainTabsComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        canActivate: [authGuard(true)],
        component: HomePage,
      },
      {
        path: 'stories',
        canActivate: [authGuard(true)],
        data: {
          index: 1,
        },
        component: StoriesPage,
      },
      {
        path: 'characters',
        canActivate: [authGuard(true)],
        data: {
          index: 2,
        },
        children: [
          {
            path: '',
            component: CharactersPage,
          },
        ],
      },
      {
        path: 'community',
        children: [
          {
            path: '',
            component: CommunityPage,
          },
          {
            path: 'character-templates',
            loadComponent: () =>
              import('./pages/community/pages/character-templates/character-templates.page').then(
                (m) => m.CharacterTemplatesPage,
              ),
          },
        ],
      },
    ],
  },
  {
    path: 'inn',
    canActivate: [authGuard(true)],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/Inn/inn.page').then((m) => m.InnPage),
      },
      {
        path: ':chat',
        data: {
          characters: false,
          settings: false,
          bookmarks: false,
          chapters: false,
        },
        loadComponent: () =>
          import('./features/chat/pages/chat/chat.page').then(
            (m) => m.ChatPage,
          ),
      },
    ],
  },
  {
    path: 'characters',
    children: [
      {
        path: 'new',
        loadComponent: () =>
          import('./pages/characters/pages/character/character.page').then(
            (m) => m.CharacterPage,
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/characters/pages/character/character.page').then(
            (m) => m.CharacterPage,
          ),
      },
    ],
  },
  {
    path: 'users',
    children: [
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/profile/profile.page').then((m) => m.ProfilePage),
      },
    ],
  },
  {
    path: 'profile',
    canActivate: [authGuard(true)],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/profile/profile.page').then((m) => m.ProfilePage),
      },
      {
        path: 'update-displayname',
        loadComponent: () =>
          import('./pages/profile/pages/update-displayname/update-displayname.page').then(
            (m) => m.UpdateDisplaynamePage,
          ),
      },
    ],
  },
  {
    path: 'friends',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/friends/friends.page').then((m) => m.FriendsPage),
      },
      {
        path: 'chat/:chat',
        data: {
          characters: false,
          settings: false,
          bookmarks: false,
          chapters: false,
        },
        loadComponent: () =>
          import('./features/chat/pages/chat/chat.page').then(
            (m) => m.ChatPage,
          ),
      },
    ],
  },
  {
    path: 'stories',
    children: [
      {
        path: 'create-story',
        loadComponent: () =>
          import('./pages/stories/pages/create-story/create-story.page').then(
            (m) => m.CreateStoryPage,
          ),
      },
      {
        path: 'create-story/preferences',
        loadComponent: () =>
          import('./pages/stories/pages/create-story/create-ai-story-preferences.page').then(
            (m) => m.CreateAiStoryPreferencesPage,
          ),
      },
      {
        path: ':story',
        component: StoryPage,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/stories/pages/story/pages/story-home/story-home.page').then(
                (m) => m.StoryHomePage,
              ),
          },
          {
            path: 'create-chat',
            loadComponent: () =>
              import('./pages/stories/pages/story/pages/create-chat/create-chat.page').then(
                (m) => m.CreateChatPage,
              ),
          },
          {
            path: 'setup',
            loadComponent: () =>
              import('./pages/stories/pages/story/pages/story-ai-setup/story-ai-setup.page').then(
                (m) => m.StoryAiSetupPage,
              ),
          },
          {
            path: 'settings',
            loadComponent: () =>
              import('./pages/stories/pages/story/pages/settings/settings.page').then(
                (m) => m.SettingsPage,
              ),
          },
          {
            path: 'operations',
            loadComponent: () =>
              import('./pages/stories/pages/story/pages/operations/operations.page').then(
                (m) => m.OperationsPage,
              ),
          },
          {
            path: 'rules',
            loadComponent: () =>
              import('./pages/stories/pages/story/pages/rules/rules.page').then(
                (m) => m.StoryRulesPage,
              ),
          },
          {
            path: 'diary',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./pages/stories/pages/story/pages/diary/diary.page').then(
                    (m) => m.DiaryPage,
                  ),
              },
              {
                path: 'chapters',
                loadComponent: () =>
                  import('./pages/stories/pages/story/pages/diary/pages/chapters/chapters.page').then(
                    (m) => m.ChaptersPage,
                  ),
              },
              {
                path: 'bookmarks',
                loadComponent: () =>
                  import('./pages/stories/pages/story/pages/diary/pages/bookmarks/bookmarks.page').then(
                    (m) => m.BookmarksPage,
                  ),
              },
              {
                path: 'setting',
                loadComponent: () =>
                  import('./pages/stories/pages/story/pages/diary/pages/campaign-setting/campaign-setting.page').then(
                    (m) => m.CampaignSettingPage,
                  ),
              },
            ],
          },
          {
            path: 'characters',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./pages/stories/pages/story/pages/characters/characters.page').then(
                    (m) => m.CharactersPage,
                  ),
              },
              {
                path: 'create',
                loadComponent: () =>
                  import('./pages/stories/pages/story/pages/create-ai-character/create-ai-character.page').then(
                    (m) => m.CreateAiCharacterPage,
                  ),
              },
              {
                path: 'new',
                loadComponent: () =>
                  import('./pages/characters/pages/character/character.page').then(
                    (m) => m.CharacterPage,
                  ),
              },
              {
                path: ':id',
                loadComponent: () =>
                  import('./pages/characters/pages/character/character.page').then(
                    (m) => m.CharacterPage,
                  ),
              },
            ],
          },
          {
            path: ':chat',
            children: [
              {
                path: '',
                data: {
                  characters: true,
                  settings: true,
                  bookmarks: true,
                  chapters: true,
                },
                loadComponent: () =>
                  import('./features/chat/pages/chat/chat.page').then(
                    (m) => m.ChatPage,
                  ),
              },
              {
                path: 'settings',
                loadComponent: () =>
                  import('./pages/stories/pages/story/pages/chat/pages/settings/settings.page').then(
                    (m) => m.SettingsPage,
                  ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'instal',
    loadComponent: () =>
      import('./pages/install/install.page').then((m) => m.InstallPage),
  },
  {
    path: 'install',
    redirectTo: 'instal',
    pathMatch: 'full',
  },
  {
    path: 'login',
    canActivate: [authGuard(false)],
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'forgot-password',
    canActivate: [authGuard(false)],
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/reset-password/reset-password.page').then(
        (m) => m.ResetPasswordPage,
      ),
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./pages/legal/legal.page').then((m) => m.LegalPage),
    data: { document: 'terms-of-service', titleKey: 'legal.termsTitle' },
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./pages/legal/legal.page').then((m) => m.LegalPage),
    data: { document: 'privacy-policy', titleKey: 'legal.privacyTitle' },
  },
  {
    path: 'cookie-policy',
    loadComponent: () =>
      import('./pages/legal/legal.page').then((m) => m.LegalPage),
    data: { document: 'cookie-policy', titleKey: 'legal.cookieTitle' },
  },
  {
    path: 'signup',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'create-displayname',
    canActivate: [authGuard(true)],
    loadComponent: () =>
      import('./pages/create-displayname/create-displayname.page').then(
        (m) => m.CreateDisplaynamePage,
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.page').then((m) => m.NotFoundPage),
  },
];
